/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UpdateScheduleRequest {
    getFixupPrototypeFunction() { return UpdateScheduleRequest.fixupPrototype; }

    static newInstance(model: Partial<UpdateScheduleRequest>): UpdateScheduleRequest {
        let obj = Object.assign(new UpdateScheduleRequest(), model);
        UpdateScheduleRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UpdateScheduleRequest>): UpdateScheduleRequest {
        if (!model) return null;
        return UpdateScheduleRequest.newInstance(<UpdateScheduleRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UpdateScheduleRequest) {
        if (!obj) return;

        models.UpdateScheduleRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UpdateScheduleRequest): boolean {
        Object.setPrototypeOf(obj, UpdateScheduleRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.schedule) {
            models.DateAndTimeDetails.fixupPrototype(this.schedule);
        }
        if (this.attributes) {
            models.AttributeDetails.fixupPrototype(this.attributes);
        }
    }

    /**
     * Schedule Name to be create
     */
    name: string;

    /**
     * Description of the schedule
     */
    description: string;

    /**
     * Recurrence of the schedule
     */
    recurrence: models.ScheduleRecurrence;

    /**
     * Schedule date and time details
     */
    schedule: models.DateAndTimeDetails;

    /**
     * Template/Policy Id.can be retrieved using the List Policy Schedules
     */
    resource: Array<string>;

    /**
     * Attribute Details
     */
    attributes: models.AttributeDetails;

    /**
     * Input Parameters for the Template/Policy
     */
    args: any;

}
